module.exports = __webpack_public_path__ + "static/img/cp01.abb71b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp01.png
// module id = 7tyW
// module chunks = 1